import { FeatureFlagKey } from 'src/ts/enums';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { getUnauthenticatedFeatureFlagValue } from 'src/features/featureFlag';

export const useUnauthenticatedFeatureFlag = (featureFlagKey: FeatureFlagKey) => {
  return useSelector((state: RootState) =>
    getUnauthenticatedFeatureFlagValue(state, featureFlagKey)
  ) as boolean;
};
